import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { ProviderEndpoint, SaveProviderEndpoint,  CommonService, GetProviderEndpoints } from 'huddyapi';




@Component({
  selector: 'edit-provider-endpoint-dialog',
  templateUrl: 'edit-provider-endpoint-dialog.component.html',
  styleUrls: ["./edit-provider-endpoint-dialog.component.scss"]
})
export class EditProviderEndpointDialog  {
  

  edited : ProviderEndpoint;

  providerEndpointForm = this.formBuilder.group({
    organizationCode: ['', [Validators.required, Validators.maxLength(255)]],
    organizationName:  ['', [Validators.required, Validators.maxLength(512)]],
    registrationId:  ['', [Validators.required, Validators.maxLength(24)]],
    endpointType :   ['', [Validators.required]],
    clientAuthType :   ['', [Validators.required]],
    apiLevel :   ['', [Validators.required]],
    clientId :   ['', [Validators.required, Validators.maxLength(64)]],
    clientSecret :   ['', [Validators.maxLength(128)]],
    redirectUri :   ['', [Validators.maxLength(2083)]],
    scope :   ['', [Validators.maxLength(2083)]],
    authorizationBaseUrl :   ['', [Validators.required, Validators.maxLength(2083)]],
    tokenUrl :   ['', [Validators.required, Validators.maxLength(2083)]],
    registerUrl :   ['', [Validators.maxLength(2083)]],
    resourceBaseUrl :   ['', [Validators.required,Validators.maxLength(2083)]],
    audience  :   ['', [Validators.maxLength(2083)]]

});

  constructor(
    public dialogRef: MatDialogRef<EditProviderEndpointDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('data', data);
    this.providerEndpointForm.setValue({
      organizationCode: data.organizationCode ?? '',
      organizationName: data.organizationName ?? '',
      registrationId : data.registrationId ?? '',
      endpointType : data.endpointType ?? 'Payor',
      clientAuthType : data.clientAuthType ?? 'PKCE',
      apiLevel : data.apiLevel ?? 'R4',
      clientId : data.clientId ?? '',
      clientSecret : data.clientSecret ?? '',
      redirectUri : data.redirectUri ?? '',
      scope : data.scope ?? '',
      authorizationBaseUrl: data.authorizationBaseUrl ?? '',
      tokenUrl : data.tokenUrl ?? '',
      registerUrl : data.registerUrl ?? '',
      resourceBaseUrl : data.resourceBaseUrl ?? 'n/a',
      audience : data.audience ?? ''
    });
    this.edited = {
      id : data.id,
      organizationCode: data.organizationCode ?? '',
      organizationName: data.organizationName ?? '',
      name : data.organizationName ?? '',
      registrationId : data.registrationId ?? '',
      endpointType : data.endpointType ?? 'Payor',
      clientAuthType : data.clientAuthType ?? 'PKCE',
      apiLevel : data.apiLevel ?? 'R4',
      clientId : data.clientId ?? '',
      clientSecret : data.clientSecret ?? '',
      redirectUri : data.redirectUri ?? '',
      scope : data.scope ?? '',
      authorizationBaseUrl: data.authorizationBaseUrl ?? '',
      tokenUrl : data.tokenUrl ?? '',
      registerUrl : data.registerUrl ?? '',
      resourceBaseUrl : data.resourceBaseUrl ?? 'n/a',
      audience : data.audience ?? ''
    };

  }

  ngOnInit(): void {
   console.log(this.edited);
  }

  isFormInValid() {
    return (this.providerEndpointForm.invalid);
  }

  onSubmitForm() {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }

  save() {
      console.log('entering save');
      let g : ProviderEndpoint = ({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        organizationCode: this.providerEndpointForm.value.organizationCode,
        organizationName: this.providerEndpointForm.value.organizationName,
        name : this.providerEndpointForm.value.organizationName,
        registrationId : this.providerEndpointForm.value.registrationId,
        endpointType :this.providerEndpointForm.value.endpointType,
        clientAuthType : this.providerEndpointForm.value.clientAuthType,
        apiLevel : this.providerEndpointForm.value.apiLevel,
        clientId : this.providerEndpointForm.value.clientId,
        clientSecret : this.providerEndpointForm.value.clientSecret,
        redirectUri :this.providerEndpointForm.value.redirectUri,
        scope : this.providerEndpointForm.value.scope,
        authorizationBaseUrl: this.providerEndpointForm.value.authorizationBaseUrl,
        tokenUrl : this.providerEndpointForm.value.tokenUrl,
        registerUrl : this.providerEndpointForm.value.registerUrl,
        resourceBaseUrl : this.providerEndpointForm.value.resourceBaseUrl,
        audience : this.providerEndpointForm.value.audience
      });
    console.log('Provider endpoint to save', g);  
    this.store.dispatch(new SaveProviderEndpoint(g)).subscribe(t => {
          this.store.dispatch(new GetProviderEndpoints(false, 0, 10, ''));
          this.close();
        });
  }

}

